<script>
import { mapGetters } from 'vuex'
import { postHotelRoomTypeFeature, getHotelRoomTypeFeature, deleteHotelRoomTypeFeature } from '@router/views/hotel/api.js'
export default {
  data() {
    return {
      isLoading: false,
      isRoomFeatureDialogShow: false,
      form: {
        title: '',
        enTitle: '',
        subTitle: '',
        maxPets: 1,
        quantity: 1,
        code: '',
        startNumber: 1, //資料設計問題 起始碼恆等於 1
        description: '',
        features: [],
      },
      featureSearchText: '',
      selectedFeatureIds: [],
      allFeatures: [],
      rules: {
        title: [{ required: true, message: '名稱為必填', trigger: 'blur' }],
        maxPets: [
          { required: true, message: '房間最多可容納數為必填', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value < 1 || value > 10) {
                callback(new Error('容納數量必須在 1 到 10 之間'))
              } else {
                callback()
              }
            },
            trigger: 'change',
          },
        ],
        quantity: [
          { required: true, message: '房間數為必填', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value < 1 || value > 100) {
                callback(new Error('房間數量必須在 1 到 100 之間'))
              } else {
                callback()
              }
            },
            trigger: 'change',
          },
        ],
        code: [{ required: true, message: '房間起始編號為必填', trigger: 'blur' }],
        features: [{ required: true, message: '至少選擇一個房間設備', trigger: 'change' }],
      },
    }
  },
  computed: {
    filterFeature() {
      return this.allFeatures.filter((feature) => feature.label.includes(this.featureSearchText))
    },
    checkAllFeatureIds() {
      return this.selectedFeatureIds.length === this.allFeatures.length && this.allFeatures.length > 0
    },
    isIndeterminateFeature() {
      return this.selectedFeatureIds.length > 0 && this.selectedFeatureIds.length < this.allFeatures.length
    },
    ...mapGetters('hotel/setting', ['productId']),
  },
  methods: {
    searchFeature(value) {
      console.log(value)
    },
    removeFeature(feature) {
      this.form.features = this.form.features.filter((e) => e !== feature)
    },
    toggleAllFeatureIds(toggleAll) {
      if (toggleAll) {
        this.selectedFeatureIds = this.allFeatures.map((feature) => feature.value)
      } else {
        this.selectedFeatureIds = []
      }
    },
    saveSelectedFeatureIds() {
      this.form.features = this.allFeatures.filter((feature) => this.selectedFeatureIds.includes(feature.value))
      this.isRoomFeatureDialogShow = false
    },
    getStepData() {
      return this.form
    },
    async validateForm() {
      try {
        const valid = await this.$refs.formRef.validate()
        return valid // true or false
      } catch (error) {
        this.$message.error('尚有必填資料未填寫')
        return false
      }
    },
    async addFeatureIfNotFound() {
      const matched = this.allFeatures.find((f) => f.label === this.featureSearchText)
      if (!matched && this.featureSearchText) {
        const res = await this.fetchAddFeature(this.featureSearchText)
        this.allFeatures.push({ label: res.items.name, value: res.items.id })
        this.featureSearchText = ''
      }
    },
    async fetchAddFeature(featureLabel) {
      try {
        this.isLoading = true
        const res = await postHotelRoomTypeFeature(this.productId, { name: featureLabel })
        this.$message.success('新增設備成功')
        return res
      } catch (error) {
        console.log(error)
        this.$message.error('新增設備失敗')
      } finally {
        this.isLoading = false
      }
    },
    async fetchRoomTypeFeatures() {
      try {
        const res = await getHotelRoomTypeFeature(this.productId)
        this.allFeatures = res.map((feature) => ({
          label: feature.name,
          value: feature.id,
        }))
        return true
      } catch (error) {
        console.log(error)
        this.$message.error('取得房型設備失敗,請稍後再試')
        return false
      }
    },
    async onClickOpenRoomFeatureDialog() {
      const success = await this.fetchRoomTypeFeatures()
      if (success) this.isRoomFeatureDialogShow = true
    },
    async onDeleteFeature(featureId) {
      await this.fetchRemoveFeature(featureId)
      await this.fetchRoomTypeFeatures()
    },
    async fetchRemoveFeature(featureId) {
      try {
        const res = await deleteHotelRoomTypeFeature(this.productId, featureId)
        if (res.code === 200) this.$message.success('刪除設備成功')
      } catch (error) {
        console.log(error)
        this.$message.error('刪除設備失敗')
      }
    },
  },
}
</script>
<template>
  <el-form class="step1" :rules="rules" :model="form" ref="formRef" @submit.native.prevent>
    <div class="field">
      <div class="form-block-title mt-0 mb-3">
        <span class="isStyleRequired">名稱</span>
      </div>
      <el-form-item prop="title">
        <el-input v-model="form.title" placeholder="請輸入名稱" />
      </el-form-item>
    </div>

    <div class="field">
      <div class="form-block-title mt-0 mb-3">
        <span>英文名稱</span>
      </div>
      <el-form-item>
        <el-input v-model="form.enTitle" placeholder="請輸入英文名稱" />
      </el-form-item>
    </div>

    <div class="field">
      <div class="form-block-title mt-0 mb-3">
        <span>副標題</span>
      </div>
      <el-form-item>
        <el-input v-model="form.subTitle" placeholder="請輸入副標題" />
      </el-form-item>
    </div>

    <div class="field">
      <div class="form-block-title mt-0 mb-3">
        <span class="isStyleRequired">房間最多可容納數</span>
      </div>
      <el-form-item prop="maxPets">
        <el-input v-model="form.maxPets" type="number" :min="1" :max="10" />
      </el-form-item>
    </div>

    <div class="field">
      <div class="form-block-title mt-0 mb-3">
        <span class="isStyleRequired">房間數</span>
      </div>
      <el-form-item prop="quantity">
        <el-input v-model="form.quantity" type="number" :min="1" :max="100" />
      </el-form-item>
    </div>

    <div class="field">
      <div class="form-block-title mt-0 mb-3">
        <span class="isStyleRequired">房間起始編號</span>
      </div>
      <el-form-item class="room-number-group" prop="code">
        <el-input v-model="form.code" placeholder="請輸入標題" />
        <span class="dash">-</span>
        <el-input v-model="form.startNumber" disabled placeholder="請輸入房間數" />
      </el-form-item>
    </div>

    <div class="form-block-title mt-0 mb-3">
      <span class="isStyleRequired">房間設備</span>
    </div>
    <div class="field block">
      <el-form-item prop="features">
        <div v-if="form.features && form.features.length">
          <el-tag v-for="feature in form.features" :key="feature.value" :closable="true" @close="removeFeature(feature)">
            {{ feature.label }}
          </el-tag>
        </div>
      </el-form-item>
      <el-button class="is-round" @click="onClickOpenRoomFeatureDialog">
        <BaseIcon name="plus" />
        新增房間設備
      </el-button>
    </div>

    <div class="field textarea">
      <div class="form-block-title mt-0 mb-3">
        <span>項目描述</span>
      </div>
      <el-form-item>
        <el-input type="textarea" v-model="form.description" :rows="6" placeholder="請輸入內容" />
      </el-form-item>
    </div>

    <el-dialog class="merchant-dialog" title="選取房間設備" :visible.sync="isRoomFeatureDialogShow" width="80%" top="0" append-to-body @close="isRoomFeatureDialogShow = false">
      <el-form label-position="top" class="isWrap" @submit.native.prevent>
        <el-form-item>
          <el-row type="flex">
            <el-col :span="19">
              <el-input v-model="featureSearchText" placeholder="搜尋" class="search-in-box" @input="searchFeature" @keydown.enter.native.prevent>
                <BaseIcon slot="suffix" name="search" class="el-input__icon" />
              </el-input>
            </el-col>
            <el-col :span="1"> </el-col>
            <el-col :span="4">
              <el-button round type="primary" style="width:100%" :loading="isLoading" @click.prevent="addFeatureIfNotFound"> 新增設備</el-button>
            </el-col>
          </el-row>
        </el-form-item>
        <div class="content">
          <el-checkbox :value="checkAllFeatureIds" :indeterminate="isIndeterminateFeature" class="check-all" @change="toggleAllFeatureIds">
            全選
            <div class="total">{{ allFeatures.length }}</div>
          </el-checkbox>
          <el-checkbox-group v-model="selectedFeatureIds">
            <el-row :gutter="20">
              <el-col v-for="f in filterFeature" :key="f.value" :span="12">
                <el-checkbox :label="f.value" class="feature-item">
                  {{ f.label }}
                  <i class="el-icon-delete" @click.stop.prevent="onDeleteFeature(f.value)" />
                </el-checkbox>
              </el-col>
            </el-row>
          </el-checkbox-group>
        </div>
      </el-form>
      <div class="two-row">
        <el-button class="is-round" @click="isRoomFeatureDialogShow = false">取消</el-button>
        <el-button class="is-round" type="primary" @click="saveSelectedFeatureIds">確定</el-button>
      </div>
    </el-dialog>
  </el-form>
</template>

<style lang="scss" scoped>
.two-row {
  display: flex;
  flex-direction: row;

  > * {
    flex: 1 0 0;
  }

  > * + * {
    margin-left: 20px;
  }
}

.step1 {
  .field {
    margin-bottom: 20px;

    &.block {
      padding: 20px;
      background: #f9f9fb 0% 0% no-repeat padding-box;
      border-radius: 8px;
      opacity: 1;

      .el-tag {
        width: 100%;
        color: #6c6b6b;
        position: relative;
        background-color: white;
        border: 1px solid #f2f2f2;
        border-radius: 8px;

        ::v-deep .el-icon-close {
          position: absolute;
          top: 7px;
          right: 4px;
          color: #121931;
        }
      }

      .el-button {
        margin-top: 60px;
        width: 100%;
      }
    }

    &.textarea {
      margin-top: 24px;

      ::v-deep .el-textarea__inner {
        background-color: white;
        border: 1px solid #e5e7eb;
        border-radius: 8px;
        padding: 12px;
      }
    }
  }
}

.room-number-group {
  ::v-deep .el-form-item__content {
    display: flex;
    align-items: center;
    gap: 15px;
  }

  .dash {
    color: #333;
    font-weight: 500;
  }
}

.feature-item {
  display: flex;
  align-items: center;
  padding: 15px 20px;
  background-color: #fff;
  border: 1px solid #eaeaea;
  border-radius: 8px;
  margin: 0 0 10px 0;

  ::v-deep .el-checkbox__label {
    flex: 1;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  span {
    color: #606266;
    font-size: 14px;
  }

  i {
    cursor: pointer;
    color: #909399;
    font-size: 14px;

    &:hover {
      color: #f56c6c;
    }
  }
}

.add-btn {
  width: 100%;
  border: 1px solid #eaeaea;
  color: #606266;
  background-color: #fff;
  border-radius: 4px;
  padding: 15px;

  i {
    margin-right: 5px;
    font-weight: bold;
  }

  &:hover {
    color: #f37736;
    border-color: #f37736;
  }
}

.merchant-dialog {
  .check-all {
    ::v-deep .total {
      position: absolute;
      top: 50%;
      right: 20px;
      transform: translateY(-50%);
    }
  }

  .content {
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    max-height: 400px;
    overflow-y: auto;

    > .el-checkbox {
      background-color: #f9f9fb;
      padding: 14px 18px;
    }

    > .el-checkbox-group {
      padding: 14px 18px;

      ::v-deep {
        .el-row {
          margin-top: -8px;
          margin-bottom: -8px;

          .el-col {
            padding-top: 8px;
            padding-bottom: 8px;
          }
        }
      }

      ::v-deep .el-checkbox {
        width: 100%;
        padding: 14px 14px;
        background: #ffffff 0% 0% no-repeat padding-box;
        border: 1px solid #e5e7eb;
        border-radius: 8px;

        &.is-checked {
          border-color: #e86a35;
        }
      }
    }
  }

  .two-row:last-child {
    margin-top: 30px;
  }
}
</style>
